// Bridges the phone's back button (and browser back) to in-app screens.
//
// Screens are plain React state, so the browser knows nothing about them and
// hardware back would leave the site. Every navigation that can be backed out
// of calls pushScreen(closeHandler): it pushes a real history entry and stacks
// the handler. Hardware/browser back fires popstate → we run handlers until our
// stack matches the entry the browser landed on. On-screen ← buttons call
// goBack() (history.back()) so both paths go through the same place and the
// stack never drifts from the history.
//
// From the root screen (launcher) the stack is empty, so back leaves the app —
// which is what Android users expect from a home screen.

type CloseHandler = () => void;

const stack: CloseHandler[] = [];

/** Call when navigating into a screen/overlay; onClose must take the UI back out of it. */
export function pushScreen(onClose: CloseHandler) {
  stack.push(onClose);
  history.pushState({ backstackDepth: stack.length }, "");
}

/** What on-screen ← / Cancel / done-and-close actions call instead of setting state directly. */
export function goBack() {
  if (stack.length > 0) history.back();
}

window.addEventListener("popstate", (event) => {
  const state = event.state as { backstackDepth?: number } | null;
  const depth = typeof state?.backstackDepth === "number" ? state.backstackDepth : 0;
  // Handles single back presses and multi-entry jumps (long-press back list).
  while (stack.length > depth) stack.pop()!();
});
